export const shortcuts = [
  {
    label: "添加成员",
    value: "add-member",
    router: "company-user",
    dialog: "add-member",
    icon: "add-member"
  },
  {
    label: "添加部门",
    value: "add-part",
    router: "company-user",
    dialog: "add-part",
    icon: "add-part"
  },
  // {
  //   label: "批量导入成员",
  //   value: "batch-import-member",
  //   router: "company-user",
  //   dialog: "batch-import-member",
  //   icon: "batch-import-member"
  // },
  {
    label: "管理员权限",
    value: "administrator-rights",
    router: "company-role",
    icon: "administrator-rights"
  },
  {
    label: "应用列表",
    value: "application-list",
    router: "company-manage-app",
    icon: "application-list"
  },
  {
    label: "项目列表",
    value: "project-list",
    router: "company-manage-project",
    icon: "project-list"
  }
]

export const memberInfos = [
  {
    label: "企业人数",
    value: "employees",
    icon: "employees"
  },
  {
    label: "未激活数",
    value: "inactive-number",
    icon: "inactive"
  },
  {
    label: "部门数",
    value: "parts",
    icon: "parts"
  }
]
